import { render, staticRenderFns } from "./ViewEditor.vue?vue&type=template&id=71e7c548"
import script from "./ViewEditor.vue?vue&type=script&lang=ts"
export * from "./ViewEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e7c548')) {
      api.createRecord('71e7c548', component.options)
    } else {
      api.reload('71e7c548', component.options)
    }
    module.hot.accept("./ViewEditor.vue?vue&type=template&id=71e7c548", function () {
      api.rerender('71e7c548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ViewEditor.vue"
export default component.exports